import { render, staticRenderFns } from "./nav_m.vue?vue&type=template&id=4a8ec077&scoped=true&"
import script from "./nav_m.vue?vue&type=script&lang=js&"
export * from "./nav_m.vue?vue&type=script&lang=js&"
import style0 from "./nav_m.vue?vue&type=style&index=0&id=4a8ec077&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a8ec077",
  null
  
)

export default component.exports